import { useMutation, useQueryClient } from "react-query";

import { useDialog } from "../../../../common";

import { SavedSubscriptionDialog } from "../../../components/SavedSubscriptionDialog";
import { subscriptionItemsKey } from "../../queries";
import { addSubscription } from "./addSubscription.fetcher";
import { AddSubscriptionMutationResult } from "./addSubscription.types";

export function useAddSubscriptionMutation(): AddSubscriptionMutationResult {
  const queryClient = useQueryClient();
  const { openModal } = useDialog();

  return useMutation(addSubscription, {
    onSettled: () => {
      queryClient.invalidateQueries(subscriptionItemsKey);
    },
    onSuccess: () => {
      openModal(SavedSubscriptionDialog);
    },
  });
}
